module.exports = __webpack_public_path__ + "static/media/BrokerZip.7b300a47.zip";